export enum NoticeBlockIconType {
	Default = '',
	Alert = 'alert',
	Info = 'info',
	Success = 'success',
}

export enum NoticeBlockSize {
	Default = '',
	Large = 'large',
}
